export default "__VITE_ASSET__CxzM23gg__"